window.updateFreeShippingBar = window.updateFreeShippingBar || function() {
  if ( !document.querySelector('.free-shipping-progress-bar') ) return;

  fetch('/cart.json')
    .then(response => response.json())
    .then(cartJson => {
      const cartTotal = cartJson?.total_price || 0;
      if ( cartTotal === 0 ) {
        document.querySelector('.free-shipping-progress-bar').classList.add('hidden');
        document.querySelector('.free-shipping-progress-bar progress').value = 0;
      } else {
        const threshold = document.querySelector('.free-shipping-progress-bar progress').max;
        if ( cartTotal >= threshold ) {
          document.querySelector('.message-before-free-shipping').classList.add('hidden');
          document.querySelector('.message-for-free-shipping').classList.remove('hidden');
        } else {
          document.querySelector('.message-before-free-shipping .money').textContent = Shopify.formatMoney(threshold-cartTotal, Shopify.shop.money_format).replace('.00', '');
          document.querySelector('.message-before-free-shipping').classList.remove('hidden');
          document.querySelector('.message-for-free-shipping').classList.add('hidden');
        }
        document.querySelector('.free-shipping-progress-bar progress').value = cartTotal;
        document.querySelector('.free-shipping-progress-bar').classList.remove('hidden');
        }
    })
    .catch(error => console.error(error));
}

window.updateFreeShippingBar();
